import { useEffect } from "react";
import { Zap } from "lucide-react";
import { usePulseUI } from "@/contexts/PulseContext";
import { useOrganization } from "@/contexts/OrganizationContext";

const ALLOWED_ROLES = new Set(["org_admin", "performance", "medical", "coach", "super_admin"]);

export function PulseFloatingButton() {
  const { toggle } = usePulseUI();
  const { currentRole, isSuperAdmin } = useOrganization();

  useEffect(() => {
    const handler = (e: KeyboardEvent) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        toggle();
      }
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [toggle]);

  if (!isSuperAdmin && !ALLOWED_ROLES.has(currentRole ?? "")) return null;

  return (
    <button
      type="button"
      onClick={toggle}
      aria-label="Open Pulse assistant"
      className="fixed right-7 bottom-[80px] md:bottom-7 z-50 h-12 w-12 rounded-full flex items-center justify-center shadow-lg hover:opacity-90 transition-opacity"
      style={{ backgroundColor: "#1a1a18" }}
    >
      <Zap className="h-5 w-5 text-white" />
    </button>
  );
}
